import { render, staticRenderFns } from "./ServiceDashboardSessionLoadBarGraph.vue?vue&type=template&id=2162576f&"
import script from "./ServiceDashboardSessionLoadBarGraph.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceDashboardSessionLoadBarGraph.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports